import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { fetchData } from "../../helper/api.interceptor";
import Swal from "sweetalert2";
import "../../customerdetails/customer-order-details.css";

const SalesExectiveModal = () => {
    const { phone } = useParams();
    const [customerData, setCustomerData] = useState(null);
    const [projects, setProjects] = useState([]);
    const [projectsMessage, setProjectsMessage] = useState(""); // ✅ new state for message

    useEffect(() => {
        const fetchCustomerAndProjects = async () => {
            try {
                const phone_number = decodeURIComponent(phone);

                // ✅ Fetch customer details
                const customerRes = await fetchData.get(`/user/by-phone-number/${phone_number}`);
                if (customerRes.status_code === 200) {
                    setCustomerData(customerRes.result);
                }

                // ✅ Fetch projects list
                const projectsRes = await fetchData.get(
                    `/projects/by-phone?sales_executive_phone=${encodeURIComponent(
                        customerRes.result?.phone_number
                    )}`
                );
                console.log("0000" + projectsRes);


                if (projectsRes.status_code === 200) {
                    setProjects(projectsRes.result.projects || []);
                    setProjectsMessage(""); // clear message
                } else if (
                    projectsRes.status_code === 404 &&
                    projectsRes.message === "No projects found for this Sales Executive"
                ) {
                    setProjects([]); // clear projects
                    setProjectsMessage(projectsRes.message); // set backend message
                }
            } catch (error) {
                console.error(error);
                Swal.fire("Error", "Something went wrong", "error");
            }
        };

        if (phone) fetchCustomerAndProjects();
    }, [phone]);

    return (
        <div className="customer-order-details">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">  Sales Executive Details</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/Sales_Executive" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Sales Executive
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Sales Executive Details</li>
                </ul>
            </div>
            <div className="row gy-2">

                {/* Personal Details */}
                <div className="col-12">
                    <div className="customer-detail-box p-20 shadow-sm">
                        <h5 className="mb-3 d-flex align-items-center gap-2">
                            <Icon icon="iconamoon:profile-circle-light" /> | Personal Details
                        </h5>
                        {customerData ? (
                            <div className="row">
                                {[
                                    { label: "Name", value: customerData.username },
                                    { label: "Phone", value: customerData.phone_number },
                                    { label: "Email", value: customerData.emailid },
                                    { label: "State", value: customerData?.address?.state },
                                    { label: "District", value: customerData?.address?.district },
                                    { label: "City/Village", value: customerData?.address?.city },
                                    { label: "Pincode", value: customerData?.address?.pincode },
                                    { label: "Warehouse Name", value: customerData?.warehouse_name },
                                ].map((item, idx) => (
                                    <div className="col-md-3" key={idx}>
                                        <h6 className="mb-1">{item.label}:</h6>
                                        <p className="mb-3">{item.value || "-"}</p>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>Loading personal details...</p>
                        )}
                    </div>
                </div>

                {/* Project Details */}
                <div className="col-12 mt-4">
                    <div className="customer-detail-box p-20 shadow-sm">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="d-flex align-items-center gap-2 mb-0">
                                <Icon icon="solar:clipboard-list-linear" /> | Project Details
                            </h5>
                            <h5 className="m-0">
                                <span className="text-black  bg-transparent">
                                    Total Projects: {projects.filter(p => p && p._id).length}
                                </span>
                            </h5>
                        </div>
                        <div className="card-body" style={{ overflowX: "auto" }}>
                            <table className="table bordered-table mb-0">
                                <thead>
                                    <tr>
                                        <th>S.L</th>
                                        <th>Customer's Name</th>
                                        <th>Customer's Number</th>
                                        <th>Order Id</th>
                                        <th>Project Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {projects.length > 0 ? (
                                        projects.map((proj, idx) =>
                                            proj ? (
                                                <tr key={proj._id || idx}>
                                                    <td>{idx + 1}</td>
                                                    <td>{proj?.personal_details?.user_name || "-"}</td>
                                                    <td>{proj?.phone_number || "-"}</td>
                                                    <td>{proj?.order_summary?.order_id || "-"}</td>
                                                    <td>{proj?.order_summary?.status || "Pending"}</td>
                                                    <td>
                                                        <Link
                                                            to={`/customer-order-details/${encodeURIComponent(
                                                                proj?.phone_number || ""
                                                            )}`}
                                                            className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        >
                                                            <Icon icon="iconamoon:eye-light" />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ) : null
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                {projectsMessage || "No Project Details Found."}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SalesExectiveModal;
